'use client';

import * as React from 'react';
import Button from '@/components/ui/Button';
import './styles.scss';

export interface IListCollapsibleItem {
  id: string;
  iconUrl?: string;
  title: string;
  intro: React.ReactNode;
  details: React.ReactNode;
  defaultOpen?: boolean;
}

export interface IListCollapsibleProps {
  items: IListCollapsibleItem[];
  labelExpand: string;
  labelCollapse: string;
}

const ListCollapsibleItem: React.FunctionComponent<IListCollapsibleItem & Pick<IListCollapsibleProps, 'labelExpand' | 'labelCollapse'>> = (
  props,
) => {
  const [expanded, setExpanded] = React.useState(props.defaultOpen || false);
  return (
    <li className={expanded ? 'is-expanded' : undefined}>
      <div className={'list-collapsible__content'}>
        <div className={'list-collapsible__heading'}>
          {props.iconUrl && (
            <div className={'list-collapsible__icon'}>
              <img
                src={props.iconUrl}
                alt={props.title}
                width={64}
                height={64}
              />
            </div>
          )}
          <div className={'list-collapsible__title'}>{props.title}</div>
        </div>
        <div className={'list-collapsible__description'}>{props.intro}</div>
        <div className={'list-collapsible__button'}>
          <Button
            onClick={(e) => {
              e.preventDefault();
              setExpanded(!expanded);
            }}
            title={expanded ? props.labelCollapse : props.labelExpand}
            iconRight={expanded ? 'arrow03-up' : 'arrow03-down'}
            theme="link"
          />
        </div>
      </div>
      {expanded && <div className={'list-collapsible__details'}>{props.details}</div>}
    </li>
  );
};

const ListCollapsible: React.FunctionComponent<IListCollapsibleProps> = (props) => {
  if (props.items.length === 0) {
    return null;
  }
  return (
    <ul className={'list-collapsible'}>
      {props.items.map((item) => (
        <ListCollapsibleItem
          labelCollapse={props.labelCollapse}
          labelExpand={props.labelExpand}
          key={item.id}
          {...item}
        />
      ))}
    </ul>
  );
};

ListCollapsible.displayName = 'ListCollapsible';

export default ListCollapsible;
